export default "__VITE_ASSET__DXlaXq1w__"